import { HashLocationStrategy, LocationStrategy, AsyncPipe } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

import { AktuelForsyningIndstillingerObserver } from "@e-forsyning/common/forsyning-indstillinger";
import { AktuelInstallationObserver, AktuelBrugersInstallationerObserver } from "@e-forsyning/common/installation";
import { NotificationDialogTriggerComponent, PushNotificationService } from "@e-forsyning/common/push-notification";
import { isTeknikerContext } from "@e-forsyning/common/util";

import { AppVaelgInstallationViewModel } from "./app-vaelg-installation.view-model";

@Component({
    selector: "app-vaelg-installation",
    templateUrl: "./app-vaelg-installation.component.html",
    styleUrls: ["./app-vaelg-installation.component.scss"],
    imports: [AsyncPipe, NotificationDialogTriggerComponent]
})
export class AppVaelgInstallationComponent implements OnInit {
    public vm$: Observable<AppVaelgInstallationViewModel>;
    public readonly showNotificationTrigger$: Observable<boolean>;

    constructor(
        private readonly aktuelBrugersInstallationerObserver: AktuelBrugersInstallationerObserver,
        private readonly aktuelInstallationObserver: AktuelInstallationObserver,
        private readonly locationStrategy: LocationStrategy,
        aktuelForsyningIndstillinger: AktuelForsyningIndstillingerObserver,
        pushNotificationService: PushNotificationService
    ) {
        const canUsePush = !isTeknikerContext() && pushNotificationService.canUsePushNotifications();
        this.showNotificationTrigger$ = aktuelForsyningIndstillinger.isPilot.pipe(
            map((isPilot) => canUsePush && isPilot),
            startWith(false)
        );
    }

    public ngOnInit(): void {
        const installationer$ = this.aktuelBrugersInstallationerObserver.valueChanges;
        const aktuelInstallation$ = this.aktuelInstallationObserver.valueChanges;
        this.vm$ = combineLatest([installationer$, aktuelInstallation$]).pipe(
            map(([installationer, aktuelInstallation]) => {
                const hashRouting = this.locationStrategy instanceof HashLocationStrategy;
                const href =
                    installationer && installationer.length > 1
                        ? hashRouting
                            ? "#/install-picker"
                            : "/install-picker"
                        : "";
                return {
                    adresse: (aktuelInstallation && aktuelInstallation.adresse) || "",
                    maalerNr: (aktuelInstallation && aktuelInstallation.maalerNr) || "",
                    vaelgInstallationHref: href
                };
            }),
            startWith({ adresse: "", maalerNr: "", vaelgInstallationHref: "" })
        );
    }

    public onLinkClick(event: MouseEvent, href: string): void {
        if (!href) {
            event.preventDefault();
        }
    }
}
